export const TEN_THOUSAND = 10000
export const APPROX_DEPOSIT_GAS = 520000
export const APPROX_WITHDRAW_GAS = 300000
export const GWEI = Math.pow(10, -9)
